function n(n,a,d,i){n._m(a);var m=d("951adf70");n._(a,"adminRoute",m),n._(a,"Admin",m);}